import { render, staticRenderFns } from "./ChangelogsView.vue?vue&type=template&id=0fa8bf75&"
import script from "./ChangelogsView.vue?vue&type=script&lang=js&"
export * from "./ChangelogsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports